import { Pipeline } from "..";
import { MailingOptionFilter } from "components/mailing-components/mailing-options-modal";

export interface MailingOptionsAutoComplete {
  higienizacao: MailingOptionFilter;
  filters: MailingOptionFilter;
  telefonia: MailingOptionFilter;
  enviaWhats: MailingOptionFilter;
  enviaDiscadora: MailingOptionFilter;
  enviaSMS: MailingOptionFilter;
  enviaAtendimento: MailingOptionFilter;
  simulacaoPortabilidade: MailingOptionFilter;
  digitacao: MailingOptionFilter;
}

function parseConfigJson(configJson: string): Record<string, any> {
  try {
    return JSON.parse(configJson);
  } catch (e) {
    return {};
  }
}

function createFilterObject(configJson: string): MailingOptionFilter {
  const parser = parseConfigJson(configJson);
  const result: MailingOptionFilter = {};

  Object.keys(parser).forEach((key) => {
    result[key] = {
      isChecked: true,
      value: parser[key],
    };
  });

  return result;
}

export function parsePipelineConfig(
  pipelines: Pipeline[]
): Partial<MailingOptionsAutoComplete> {
  const config: Partial<MailingOptionsAutoComplete> = {
    higienizacao: {},
    filters: {},
    telefonia: {},
    enviaWhats: {},
    enviaDiscadora: {},
    enviaSMS: {},
    enviaAtendimento: {},
    simulacaoPortabilidade: {},
    digitacao: {},
  };

  pipelines.forEach((pipeline) => {
    if (!pipeline.configJson) return;

    switch (pipeline.pipelineStage) {
      case "HIGIENIZACAO":
        config.higienizacao = createFilterObject(pipeline.configJson);
        break;
      case "FILTRO":
        config.filters = createFilterObject(pipeline.configJson);
        break;
      case "TELEFONIA":
        config.telefonia = createFilterObject(pipeline.configJson);
        break;
      case "DIGITACAO":
        config.digitacao = createFilterObject(pipeline.configJson);
        break;
      case "ENVIA_WHATS":
        config.enviaWhats = createFilterObject(pipeline.configJson);
        break;
      case "ENVIA_CAMPANHA_SMS":
        config.enviaSMS = createFilterObject(pipeline.configJson);
        break;
      case "ENVIA_DISCADORA":
        config.enviaDiscadora = createFilterObject(pipeline.configJson);
        break;
      case "ENVIA_ATENDIMENTO":
        config.enviaAtendimento = createFilterObject(pipeline.configJson);
        break;
      case "SIMULACAO_PORTABILIDADE":
        const value = parseConfigJson(pipeline.configJson);
        config.simulacaoPortabilidade = {
          SIMULACAO_PORTABILIDADE: {
            isChecked: true,
            value: value,
          },
        };
        break;
    }
  });

  return config;
}
